import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {withStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import SvgIconAccount from '@material-ui/icons/AccountCircle';
import SvgIconAbout from '@material-ui/icons/InfoOutlined';
import SvgIconSignOut from '@material-ui/icons/ExitToApp';

import PopoverMenu from './Popover'

const styles = (theme) => {
    return {
        iconButton: {
            position: 'relative',
            marginTop: 0,
            marginBottom: 0,
            padding: 0,
            width: 36,
            height: 36,
        },
        icon: {
            ...theme.iconStyle.size[28],
            ...theme.iconStyle.light,
            margin: 4,
        },
        popover: {
            marginRight: 11,
        },
        listMenu: {
            width: 200,
        },
        listItemIcon: {
            ...theme.iconStyle.size[24],
            ...theme.iconStyle.light,
            margin: 0,
        },
        listItemButton: {
            transition: 'unset',
            '&:hover': {
                backgroundColor: theme.palette.primary.hoverOverlay,
            }
        },
        listItemLabel: {
            color: theme.palette.primary.displayText,
        },
    };
}

class Avatar extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
        };
    }

    shouldComponentUpdate = (nextProps, nextState) => {
        return (this.state.open !== nextState.open);
    }

    render = () => {
        const {classes} = this.props;

        return (
            <div>
                <IconButton
                    className={classes.iconButton}
                    onClick={this._handleClick}
                >
                    <SvgIconAccount className={classes.icon}/>
                </IconButton>
                <PopoverMenu
                    className={classes.popover}
                    open={this.state.open}
                    onClose={this._handleClose}
                >
                    <List
                        className={classes.listMenu}
                        dense={true}
                    >
                        <ListItem
                            classes={{button: classes.listItemButton}}
                            button={true}
                            onClick={this._handleAbout}
                        >
                            <ListItemIcon>
                                <SvgIconAbout className={classes.listItemIcon}/>
                            </ListItemIcon>
                            <ListItemText disableTypography={true}>
                                <Typography
                                    className={classes.listItemLabel}
                                    align='left'
                                >
                                    About
                                </Typography>
                            </ListItemText>
                        </ListItem>
                        <ListItem
                            classes={{button: classes.listItemButton}}
                            button={true}
                            onClick={this._handleSignout}
                        >
                            <ListItemIcon>
                                <SvgIconSignOut className={classes.listItemIcon}/>
                            </ListItemIcon>
                            <ListItemText disableTypography={true}>
                                <Typography
                                    className={classes.listItemLabel}
                                    align='left'
                                >
                                    Sign out
                                </Typography>
                            </ListItemText>
                        </ListItem>
                    </List>
                </PopoverMenu>
            </div>
        );
    }

    _handleClick = (e) => {
        e.preventDefault();

        this.setState({
            open: true,
        });
    }

    _handleClose = (e) => {
        e.preventDefault();

        this.setState({
            open: false,
        });
    }

    _handleAbout = (e) => {
        this._onChange(e, 'about');
    }

    _handleSignout = (e) => {
        this._onChange(e, 'signout');
    }

    _onChange = (e, value) => {
        this._handleClose(e);

        if (this.props.onChange) {
            this.props.onChange(e, value);
        }
    }
}

Avatar.propTypes = {
    onChange: PropTypes.func.isRequired,
}

export default withStyles(styles)(Avatar);
